/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
};

const ChevronDownIcon: FC<IProps> = ({ width = 24, height = 22, color = "#262626", className }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="chevron-down">
      <path
        id="Vector"
        d="M5.92358 8.22656L11.8467 13.7109L17.7698 8.22656"
        stroke={color}
        strokeWidth="1.82812"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default ChevronDownIcon;
